<template>
  <span>
    <spinner class="spinner-centered" v-if="dataLoading === true" line-fg-color="#28AFAF" size="large"></spinner>
    <v-app v-else>
      <!-- navigation drawer -->
      <v-navigation-drawer
      
        persistent
        v-model="drawer"
        enable-resize-watcher
        app
      >

        <v-card class="elevation-3">
          <v-card-media>
            <v-container fluid fill-height grid-list-lg>
              <v-layout justify-center
                  align-center>
              <v-avatar
                      :size="avatarSize"
                    >
                    <img :src="meProps.logo_url || defaultLogo" alt="avatar">
                </v-avatar>
              </v-layout>
            </v-container>
          </v-card-media>
          <v-card-title>
          <v-list dense>
            <v-list-tile>
            <v-list-tile-action>
                <v-icon color="primary">account_box</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ meProps.first_name }} {{ meProps.last_name}}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
            <v-list-tile-action>
                <v-icon color="primary">work</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ meProps.company }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
            <v-list-tile-action>
                <v-icon color="primary">mail</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ meProps.email }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
            <v-list-tile-action>
                <v-icon color="primary">money</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>$ {{ meProps.balance }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
            <v-list-tile-action>
                <v-icon color="primary">fingerprint</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>ID {{meProps.id}}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          </v-card-title>
        </v-card>
        <v-spacer></v-spacer>
        <v-list>
          <v-list-group v-for="item in items" :value="item.active" v-bind:key="item.title">
              <v-list-tile slot="item">
                <v-list-tile-action>
                  <v-icon>{{ item.action }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-icon>keyboard_arrow_down</v-icon>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile v-for="subItem in item.items" v-bind:key="subItem.title"  :to="subItem.route">
                  <v-list-tile-content >
                    <v-list-tile-title>
                      {{ subItem.title }}
                    </v-list-tile-title>
                  </v-list-tile-content>
              </v-list-tile>
            </v-list-group>
            <v-list-tile v-for="item in menuItems" :key="item.title" :to="item.route" exact>
              <v-list-tile-action primary>
                <v-icon left>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
        </v-list>
      </v-navigation-drawer>
      <!-- end of navigation drawer -->
      
      <!-- toolbar -->
      <v-toolbar color="indigo" dark fixed app>
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <v-toolbar-title>Songa Insurance</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn flat @click="logout">
            <v-icon left>lock</v-icon>
            Logout
          </v-btn>
      </v-toolbar>
      <!-- end of toolbar -->
      <main>
        <v-content>
          <v-container fluid fill-height>
              <router-view></router-view>
          </v-container>
        </v-content>
      </main>
      <v-footer color="indigo" app>
        <span class="white--text">&copy; Songa Insurance</span>
      </v-footer>
    </v-app>
  </span>
</template>

<script>
import axios from 'axios'
import Spinner from 'vue-simple-spinner'
import defaultLogo from '../../../assets/placeholder_profile_photo-200x200.png'
export default {
    components: {
      Spinner
    },
    data: () => ({
      drawer: true,
      dataLoading: true,
      binging : true,
      defaultLogo: defaultLogo,
      items: [
         {
            action: 'assignment',
            title: 'Insurance Policy',
            active: true,
            items: [
              { action:'add', title: 'New Insurance Policy', route: '/agency/new_insurance' },
              { action:'add', title: 'New Insurance Policy - Turkey', route: '/agency/new_insurance_turkey' },
              { action:'add', title: 'Issued Policies', route: '/agency/issued_policies' }
            ]
          }
      ],
      menuItems: [
          {icon: 'supervisor_account', title: 'Account', route: '/agency/account'},
          {icon: 'assessment', title: 'Sales Reports', route: '/agency/sales'}
        ],
        meProps: {}
    }),
    props: {
      source: String
    },    
    computed: {
      avatarSize () {
        return `150px`
      },
      binding () {
        if (this.$vuetify.breakpoint.xs) {
          return false
        } else {
          return true
        }
      }
    },
    methods: {
      logout () {
            this.$auth.destroyToken()
            this.$router.push('/auth/login');
      },
      getMe() {
        axios.get('/me')
        .then(res => {
          this.meProps = res.data;
          this.isProvider()
          this.dataLoading = !this.dataLoading
        })
      },
      updateBalance() {
        axios.get('/me')
        .then(res => {
          this.meProps.balance = res.data.balance;
        })
      },
      isProvider() {
        if (this.meProps.is_provider === true) {
          this.menuItems.splice(1,0, {icon: 'work', title: 'Agencies', route: '/agency/agencies'})
          this.menuItems.splice(2,0, {icon: 'content_copy', title: 'Transaction Reports', route: '/agency/transaction'})
          this.menuItems.push({icon: 'description', title: 'Summary Reports', route: '/agency/summary'})
        }
      }
    },
    created() {
      this.getMe()
    },
    mounted() {
        this.$root.$on('updateBalance', () => {
            this.updateBalance();
        }
      )
    }
  }
</script>

<style scoped>
.indigo {
  background-color: #28AFAF !important
}
.spinner-centered {
  position: fixed; /* or absolute */
  top: 50%;
  left: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/agency/Views/AgencyFront.vue